"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: style
  }, /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
    fill: "#3665CF",
    x: "0",
    y: "0",
    width: "48",
    height: "38",
    rx: "5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fill: "#3B6FD3",
    x: "0",
    y: "33",
    width: "48",
    height: "15",
    rx: "5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-0.9084375,26.8234375 L13.4355276,13.4394724 L27.0836082,27.087553 L49.2535993,3.95756195 L49.2535993,38.4548233 L-1.02399309,38.4548233 L-0.9084375,26.8234375 Z",
    fill: "#3B6FD3"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-0.9084375,29.8234375 L-0.9084375,29.8234375 L-1.02399309,51.4548233 L49.2535993,51.4548233 L49.2535993,6.95756195 L27.0836082,30.087553 L13.4355276,16.4394724 L-0.9084375,29.8234375 Z M-1.78167459,27.8875652 L12.5622905,14.5036001 L13.4663217,13.6600731 L14.3406243,14.5343757 L27.9887049,28.1824563 L26.1595382,28.201836 L48.3295292,5.071845 L50.5335993,2.77233479 L50.5335993,6.95756195 L50.5335993,51.4548233 L50.5335993,52.7348233 L49.2535993,52.7348233 L-1.02399309,52.7348233 L-2.31084916,52.7348233 L-2.30397483,51.4479856 L-2.18841924,29.8165998 L-2.18546902,29.2643348 L-1.78167459,27.8875652 Z",
    fill: "#57A3EC"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fill: "#FFFFFF",
    x: "11",
    y: "27",
    width: "5",
    height: "13",
    rx: "0.64"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fill: "#FFFFFF",
    x: "18",
    y: "21",
    width: "5",
    height: "19",
    rx: "0.64"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fill: "#FFFFFF",
    x: "25",
    y: "16",
    width: "5",
    height: "24",
    rx: "0.64"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fill: "#FFFFFF",
    x: "32",
    y: "10",
    width: "5",
    height: "30",
    rx: "0.64"
  }))));
};

exports["default"] = _default;